import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusFaulted = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
			fill: "#FFD0C8"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_61_2012)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M9.99992 18.3541C9.7777 18.3541 9.56589 18.3125 9.3645 18.2291C9.16311 18.1458 8.97909 18.0278 8.81242 17.875L2.12492 11.1875C1.97214 11.0208 1.85409 10.8368 1.77075 10.6354C1.68742 10.434 1.64575 10.2222 1.64575 9.99998C1.64575 9.77776 1.68742 9.56248 1.77075 9.35415C1.85409 9.14581 1.97214 8.96526 2.12492 8.81248L8.81242 2.12498C8.97909 1.95831 9.16311 1.83679 9.3645 1.7604C9.56589 1.68401 9.7777 1.64581 9.99992 1.64581C10.2221 1.64581 10.4374 1.68401 10.6458 1.7604C10.8541 1.83679 11.0346 1.95831 11.1874 2.12498L17.8749 8.81248C18.0416 8.96526 18.1631 9.14581 18.2395 9.35415C18.3159 9.56248 18.3541 9.77776 18.3541 9.99998C18.3541 10.2222 18.3159 10.434 18.2395 10.6354C18.1631 10.8368 18.0416 11.0208 17.8749 11.1875L11.1874 17.875C11.0346 18.0278 10.8541 18.1458 10.6458 18.2291C10.4374 18.3125 10.2221 18.3541 9.99992 18.3541ZM9.99992 10.8333C10.236 10.8333 10.4339 10.7535 10.5937 10.5937C10.7534 10.434 10.8333 10.2361 10.8333 9.99998V6.66665C10.8333 6.43054 10.7534 6.23262 10.5937 6.0729C10.4339 5.91317 10.236 5.83331 9.99992 5.83331C9.76381 5.83331 9.56589 5.91317 9.40617 6.0729C9.24645 6.23262 9.16659 6.43054 9.16659 6.66665V9.99998C9.16659 10.2361 9.24645 10.434 9.40617 10.5937C9.56589 10.7535 9.76381 10.8333 9.99992 10.8333ZM9.99992 13.3333C10.236 13.3333 10.4339 13.2535 10.5937 13.0937C10.7534 12.934 10.8333 12.7361 10.8333 12.5C10.8333 12.2639 10.7534 12.066 10.5937 11.9062C10.4339 11.7465 10.236 11.6666 9.99992 11.6666C9.76381 11.6666 9.56589 11.7465 9.40617 11.9062C9.24645 12.066 9.16659 12.2639 9.16659 12.5C9.16659 12.7361 9.24645 12.934 9.40617 13.0937C9.56589 13.2535 9.76381 13.3333 9.99992 13.3333Z",
				fill: "#960505"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_61_2012",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
export default SvgStatusFaulted;
